import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import { List as NavIcon } from "@phosphor-icons/react/List";
import { Plus as PlusIcon } from "@phosphor-icons/react/Plus";
import { useFormik } from "formik";
import { SortableMenu } from "~ui-components/components/molecules/map-menu/sortable-menu";

interface Navigator {
	active: boolean;
	content: string;
	index: number;
	key: string;
	label: string;
	width: number;
	id: string;
}

export interface MapMenuInput {
	enableNavigation: boolean;
	navigators: Navigator[];
}

export interface MapMenuProps {
	form: ReturnType<typeof useFormik<MapMenuInput>>;
	onCreateTask?: () => void | undefined;
}

export const MapMenu = (props: MapMenuProps) => {
	const { form, onCreateTask } = props;
	const { values, handleChange, setFieldValue } = form;

	return (
		<form onSubmit={form.handleSubmit}>
			<Card>
				<CardHeader
					avatar={
						<Avatar>
							<NavIcon fontSize="var(--Icon-fontSize)" />
						</Avatar>
					}
					title="Map menu"
				/>

				<CardContent>
					<Stack spacing={3}>
						<FormControl>
							<FormControlLabel
								control={
									<Switch
										name="enableNavigation"
										checked={values.enableNavigation}
										onChange={handleChange}
									/>
								}
								label="Display menu"
							/>
						</FormControl>

						{values.enableNavigation && (
							<Stack spacing={2}>
								<Button
									color="secondary"
									onClick={() => onCreateTask?.()}
									startIcon={<PlusIcon />}>
									Add menu item
								</Button>
								<SortableMenu
									navigators={form.values.navigators}
									onChange={(navigators) =>
										setFieldValue("navigators", navigators)
									}
								/>
							</Stack>
						)}
					</Stack>
				</CardContent>

				<CardActions sx={{ justifyContent: "flex-end" }}>
					<Button color="secondary">Cancel</Button>
					<Button
						variant="contained"
						type="submit">
						Save changes
					</Button>
				</CardActions>
			</Card>
		</form>
	);
};
